<template>
  <v-dialog v-model="showDialog" max-width="1100px">
    <template v-slot:activator="{ on }">
      <v-btn
        v-if='hasDSSAccess'
        @click="openMDSS"
        v-on="on"
        x-large
        text
        :color="color"
      >
        <smart-icon
          v-if="!!icon"
          class="mr-2"
          :icon="icon"
          :iconColor="$color.coro['primary-500']"
        />
        {{ $ucfirst($t("patient.openmedicationdss")) }}
      </v-btn>
    </template>
    <div class="dashboard-dialog-window">
      <div class="dashboard-dialog-window__message">
        {{ $ucfirst($t('patient.enterSubjectId')) }}
      </div>
      <v-text-field
        class="mt-6"
        v-model="patientStudyId"
        dense
        :error="!!errorMessage"
        :error-messages="errorMessage"
        :placeholder="$ucfirst($t('pdf.medicationPrescription.subjectId', {catalog: 'messages'}))"
        ref="dialogInput"
      >
      </v-text-field>
      <div class="dashboard-dialog-window__actions mt-6">
        <v-btn
          x-large
          text
          class="ml-4 mt-2"
          @click="openMDSS"
        >
          {{ $ucfirst($t('patient.openmedicationdss')) }}
        </v-btn>
        <v-btn
          x-large
          text
          class="ml-4 mt-2"
          @click="closeDialog"
          color="primary"
        >
          {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import SmartIcon from "./SmartIcon.vue";

/**
 * Component OpenDSSButton.vue
 *
 * @module OpenDSSButton
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/OpenDSSButton.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "OpenDSSButton",
  components: { SmartIcon },
  props: {
    color: {
      type: String,
      default: () => 'default'
    },
    icon: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    ...mapGetters({
      studyId: "patientSummary/studyId",
      hasDSSAccess: "user/hasDSSAccess"
    }),
  },
  data() {
    return {
      showDialog: false,
      patientStudyId: '',
      errorMessage: ''
    }
  },
  watch: {
    showDialog(curr) {
      if (curr) {
        setTimeout(() => {
          this.$refs.dialogInput.focus();
        }, 200)
      }
    }
  },
  methods: {
    openMDSS() {
      if (this.showDialog === true) {
        if (!this.patientStudyId) {
          this.errorMessage = this.$ucfirst(this.$t("validation.IS_REQUIRED"))
        } else if (this.patientStudyId.toLowerCase() !== this.studyId.toLowerCase()) {
          this.errorMessage = '';
          this.$toasted.show(
            this.$ucfirst(this.$t('validation.subjectIdDoesntCorrespond')) + ' ' +
            this.$ucfirst(this.$t('validation.enterCorrectIdToOpenMDSS')), {
              type : 'error',
              position: 'bottom-center',
              duration : 6000
            }
          );
        } else {
          this.$router.push({ name: 'DSSCardioMedication', patientId: this.patientId });
          this.closeDialog();
        }
      } else {
        this.showDialog = true
      }
    },

    closeDialog() {
      this.showDialog = false;
      this.errorMessage = '';
      this.patientStudyId = '';
    }
  }
}
</script>
